export const MelayuToolsList = [
  {
    name: "Bekas Lilin",
    img_src: "https://66.media.tumblr.com/77d0dccd62fed0912077339968097784/c0f7a0a2a0e79625-91/s540x810/3d087f4b690e8dcac934446ebfe9397289ffd113.png",
    sub_img: "https://66.media.tumblr.com/77d0dccd62fed0912077339968097784/c0f7a0a2a0e79625-91/s540x810/3d087f4b690e8dcac934446ebfe9397289ffd113.png",
    description: "Bekas Lilin in literal translation is a candle stick. Because it was made from copper, it is very hardy and almost unbreakable when fall. ",
    url: "Bekas-Lilin"
  },

  {
    name: "Acuan Bahulu",
    img_src:"https://66.media.tumblr.com/a798d78dda22971e60c4508688279b9d/e546d39eb240fc02-4c/s250x400/417565de6bfa5fbe4b8beaca50055d8a1596328f.png",
    sub_img: "https://66.media.tumblr.com/a798d78dda22971e60c4508688279b9d/e546d39eb240fc02-4c/s250x400/417565de6bfa5fbe4b8beaca50055d8a1596328f.png",
    description: "Acuan Bahulu is a mould used to bake and shape the ‘bahulu’, a traditional Malay pastry. The pan is made of metal intended to prevent it from burning when baking.",
    url: "Acuan-Bahulu"

  },

  {
    name: "Batok",
    img_src: "https://66.media.tumblr.com/7edd8a0a57dd9b51f285fd0818be9da4/1368a1bdbc202a60-f1/s540x810/a32da46696dc0aa7be8080157c98e81ce965003d.png",
    sub_img: "https://66.media.tumblr.com/7edd8a0a57dd9b51f285fd0818be9da4/1368a1bdbc202a60-f1/s540x810/a32da46696dc0aa7be8080157c98e81ce965003d.png",
    description: "Batok was a scoop made from coconut shell. In the past, before someone had to enter the house, they would have to wash their feet using the batok to scoop water from the water container stored at the edge of the stairwell.",
    url:"Batok"
  },

  {
    name: "Acuan Kuih Sepit",
    img_src: "https://66.media.tumblr.com/59c958b718cdf6cbdba7259d42e2737b/e546d39eb240fc02-bb/s540x810/5af26d37d69bdf98d8d7c90ad5166a51b0e5c90e.png",
    sub_img: "https://66.media.tumblr.com/59c958b718cdf6cbdba7259d42e2737b/e546d39eb240fc02-bb/s540x810/5af26d37d69bdf98d8d7c90ad5166a51b0e5c90e.png",
    description: "The Acuan Kuih Sepit by literal translation is a Kuih Sepit (a traditional cake) mould. In order to make the cake, ones would have to pour the batter between the iron surfaces. Then, they would have to grill the batter over hot cindered charcoal. ",
    url:"Pejek"
  },
  {
    name: "Periuk Nasi",
    img_src: "https://66.media.tumblr.com/3884349d7afad2a149d787c8fe6b86bb/e546d39eb240fc02-98/s540x810/c9382ef08d66dcb2e3022dbfbacf9315fec71636.png",
    sub_img: "https://66.media.tumblr.com/3884349d7afad2a149d787c8fe6b86bb/e546d39eb240fc02-98/s540x810/c9382ef08d66dcb2e3022dbfbacf9315fec71636.png",
    description:"The traditional way to cook rice is on stovetops. Periuk Nasi in literal translation is the rice pot. It is made from metal and its meant to stand through the test of times.",
    url:"Periuk-Nasi"
  },

  {
    name: "Nyiru @ Tampik",
    img_src: "https://66.media.tumblr.com/afdacde72fb6650a53ab3621ae0b0212/1368a1bdbc202a60-93/s540x810/c875cf952ad413b6481a7e067ab67b617e27a4cb.png",
    sub_img: "https://66.media.tumblr.com/afdacde72fb6650a53ab3621ae0b0212/1368a1bdbc202a60-93/s540x810/c875cf952ad413b6481a7e067ab67b617e27a4cb.png",
    description: "Nyiru @ Tampik is an agricultural tool used when harvesting paddy seeds. It can come in various shapes and sizes.  Made out of woven bamboo, it has a hard frame to hold the item in place and sturdy. ",
    url: "Nyiru-Tampik"
  },

  {
    name: "Tungku Dapur",
    img_src:"https://66.media.tumblr.com/70ffa3a90d57e7eab8807f7f9833702d/e546d39eb240fc02-62/s540x810/e9ef797f3bc396a65eab2291a11ac519ad43ccad.png",
    sub_img:"https://66.media.tumblr.com/70ffa3a90d57e7eab8807f7f9833702d/e546d39eb240fc02-62/s540x810/e9ef797f3bc396a65eab2291a11ac519ad43ccad.png",
    description:"Tungku Dapur is a place for cooking. It functions as a grill or a stove. To ensure that it is very resistant to heat, the entire structure is made from iron.",
    url:"Tungku-Dapur"
  },

  {
    name:"Penapis",
    img_src:"https://66.media.tumblr.com/ae8ae06848d2ccb25ecf01eccfb4f1db/1368a1bdbc202a60-38/s540x810/8773bb96bc502122c5458649123189612cd3fa0d.png",
    sub_img:"https://66.media.tumblr.com/ae8ae06848d2ccb25ecf01eccfb4f1db/1368a1bdbc202a60-38/s540x810/8773bb96bc502122c5458649123189612cd3fa0d.png",
    description:"Penapis is an agricultural tool that functions as a sifter. The whole structure of the Penapis is handmade from woven Nipah leaves, as the main body, and cane, as the outer frame. ",
    url:"Penapis"
  },

  {
    name:"Pengukur Kelapa",
    img_src:"https://66.media.tumblr.com/4adcda0f5bab86c51b8a36df579a9185/c0f7a0a2a0e79625-d8/s400x600/c253c7c8a07b01061f076244ae1396a7c0a5768d.png",
    sub_img:"https://66.media.tumblr.com/4adcda0f5bab86c51b8a36df579a9185/c0f7a0a2a0e79625-d8/s400x600/c253c7c8a07b01061f076244ae1396a7c0a5768d.png",
    description:"Pengukur Kelapa is used to physically grate coconuts. The body of the Pengukur Kelapa is made of wood whereas the blade is usually made from iron.",
    url:"Pengukur-Kelapa"
  },

  {
    name:"Tepak Sirih",
    img_src:"https://66.media.tumblr.com/72bfec7579be38898c37985520ec9e51/bf1d594385396fcb-10/s250x400/23f0bb55dbde92724c79642bc5dac1e9736801d0.png",
    sub_img:"https://66.media.tumblr.com/72bfec7579be38898c37985520ec9e51/bf1d594385396fcb-10/s250x400/23f0bb55dbde92724c79642bc5dac1e9736801d0.png",
    description:"The Tepak Sirih or betel quid boxes is usually used as an adornment and in official ceremonies for its cultural symbolism and significance. The Tepak Sirih ceremony is a traditional Malay welcome in which the offering of betel nuts serves to remind guests of the purity and strength of friendship. The among the ingredients available for betel chewing which are placed into this betel boxes are: Areca nut (pinang),lime betel (kapur), Gambir, and betel leaves (daun sirih). Also commonly included in the betel box is Kacip, a nutcracker for the Areca nut.",
    url:"Tepak-Sirih"
  },

  {
    name:"Kacip Pinang",
    img_src:"https://66.media.tumblr.com/3ba3d03f132414625926993b2f8e5da1/bf1d594385396fcb-da/s400x600/03b30d81382026933652a158603dcc5d9c3d675c.png",
    sub_img:"https://66.media.tumblr.com/3ba3d03f132414625926993b2f8e5da1/bf1d594385396fcb-da/s400x600/03b30d81382026933652a158603dcc5d9c3d675c.png",
    description:"Kacip, or the nutcracker, is made from  hard metal using the round iron rod and chainsaw for the Kacip’s blade. The process is very intricate and requires mastery from the craftsmen in order to make one. The Kacip is an essential component to complete a Tepak Sirih.",
    url:"Kacip-Pinang"
  }
];

export const MelayuHandiList = [
  {
    name: "Labu Sayong",
    img_src: "https://66.media.tumblr.com/d4cd065e43fc509497c08285e543f92b/1368a1bdbc202a60-6d/s540x810/4e3e29424ddc841e8e49ffc293cb2aa910c8f51e.png",
    sub_img: "https://66.media.tumblr.com/d4cd065e43fc509497c08285e543f92b/1368a1bdbc202a60-6d/s540x810/4e3e29424ddc841e8e49ffc293cb2aa910c8f51e.png",
    description: "Labu Sayong is an artefact used to store water. It is made from clay. The carving motifs on the Labu Sayong are often inspired by traditional elements such as ‘bunga tanjung’, ‘cengkih’, ‘pucuk rebung’, and paddy. ",
    url: "Labu-Sayong"
  },

  {
    name: "Terendak",
    img_src: "https://66.media.tumblr.com/cbe7709502bf96394a1318d6c7578415/1368a1bdbc202a60-72/s540x810/f0e74eac6829d723040119bb69abef156c57c430.png",
    sub_img: "https://66.media.tumblr.com/cbe7709502bf96394a1318d6c7578415/1368a1bdbc202a60-72/s540x810/f0e74eac6829d723040119bb69abef156c57c430.png",
    description: "Terendak by definition is a conically-shaped headwear. It is usually made from the ‘Nipah’ leaves, bamboo or rattan. The process of making the Terendak is not as simple as it seems as it requires a certain type of skills to be able to come up with an interesting design. Although Terendak is a well-known artefact in the Melanau community as it is part of their traditional costume, the Terendak is also used by the Malay community of Sarawak as a headgear for farmers when they are working in the the field or often worn by fishermen when they were going off to sea fishing.",
    url: "Terendak"
  },

  {
    name: "Tempayan",
    img_src: "https://66.media.tumblr.com/52c460de5dcdc60343ca29dd023da8d6/1368a1bdbc202a60-3d/s540x810/a5fc707475f100a21f17db037812e0074ac5762c.png",
    sub_img: "https://66.media.tumblr.com/52c460de5dcdc60343ca29dd023da8d6/1368a1bdbc202a60-3d/s540x810/a5fc707475f100a21f17db037812e0074ac5762c.png",
    description: "Tempayan is a container made of pottery. In the 60s, the Malay community in the village would place the tempayan on top of the stairs to store water. There are different types of tempayan available: ‘Temapayan beras’, ‘tempayan taban’, ‘tempayan gumbang’, and ‘tempayan telur buaya’. ",
    url: "Tempayan"
  },

];

export const MelayuMusicList = [
  {
    name: "Gendang",
    img_src: "https://66.media.tumblr.com/f2f18866515f5358c83ed6a8d0131d32/e546d39eb240fc02-7e/s540x810/20e9941aaf714e37a623f734e85c145b61846568.png",
    sub_img: "https://66.media.tumblr.com/f2f18866515f5358c83ed6a8d0131d32/e546d39eb240fc02-7e/s540x810/20e9941aaf714e37a623f734e85c145b61846568.png",
    description: "The Gendang is a traditional instrument of the Malay community. The surface of the Gendang is usually made from buffalo, goat or cow skin. The Gendang is usually played in an events or ceremonies especially during ‘bermukun’.",
    url: "Gendang"
  },

  {
    name:"Kompang",
    img_src:"https://66.media.tumblr.com/0fc14f438c0cb67138344a1043e519df/bf1d594385396fcb-13/s540x810/c90027f2146d443f1c92e83ffc997600661c243b.png",
    sub_img:"https://66.media.tumblr.com/0fc14f438c0cb67138344a1043e519df/bf1d594385396fcb-13/s540x810/c90027f2146d443f1c92e83ffc997600661c243b.png",
    description:"Kompang is arguably is the most popular Malay traditional instrument. Resembling the tambourine, the kompang is approximately 40cm in diameter, with a narrow circular frame called the balos (made out of the dried wood of the balau tree) that is covered with a goathide skin on one side (which serves as the drumhead).This hand drum is most commonly played in a large kompang ensemble, where various rhythmic composite patterns are produced by an interlocking technique; sometimes to accompany the choral singing of zikir.It is believed to be of Arab origin, introduced to Malaysia during the days of the Malay Sultanate by traders.",
    url:"Kompang"
  },

];

export const MelayuOthersList = [
  {
    name: "Parang Lama",
    img_src: "https://66.media.tumblr.com/e1698f7596ce5de77a63a479d0dd1c62/e546d39eb240fc02-b9/s540x810/5af5fd0a310c4dc4ca1bb8187e35cfe6fdb0b23a.png",
    sub_img: "https://66.media.tumblr.com/e1698f7596ce5de77a63a479d0dd1c62/e546d39eb240fc02-b9/s540x810/5af5fd0a310c4dc4ca1bb8187e35cfe6fdb0b23a.png",
    description: "The Parang Lama is traditional weapon in a form of a machete. It is used for hunters and the community alike as weapon. Its sheet was made by two pieces of wood sticking together. Some of the sheet are decorated with attractive carvings. ",
    url: "Parang-Lama"
  },

  {
    name:"Keris",
    img_src:"https://66.media.tumblr.com/0ee91210af915444b8ccfe30fa4e9cbf/e546d39eb240fc02-14/s400x600/4e3f0f1e817fbc2b052329ec2d8bb54345273bd3.png",
    sub_img:"https://66.media.tumblr.com/0ee91210af915444b8ccfe30fa4e9cbf/e546d39eb240fc02-14/s400x600/4e3f0f1e817fbc2b052329ec2d8bb54345273bd3.png",
    description:"The Keris is probably the most common weapon for self-defence associated with the Malay community. However, not all Malays in Sarawak used to carry Keris around or even have it in possession. Only few places like Kampung Maludam and some places in Kuching would carry the Keris along when they went into the woods.",
    url:"Keris"
  },

  {
    name: "Almari Hias",
    img_src: "https://66.media.tumblr.com/f7bbd4ce2f66c5737ca91f8d74feb749/e546d39eb240fc02-46/s540x810/31777184906fba12d1281b799653287f549faed6.png",
    sub_img: "https://66.media.tumblr.com/f7bbd4ce2f66c5737ca91f8d74feb749/e546d39eb240fc02-46/s540x810/31777184906fba12d1281b799653287f549faed6.png",
    description: "Almari Hias functions as a traditional vanity with only the mirror. It is usually made from carved hard wood with variety of designs. ",
    url: "Almari-Hias"
  },

  {
    name: "Tikar Mengkuang",
    img_src: "https://66.media.tumblr.com/8045d42cc40bbb37b42081b152c0bb36/1368a1bdbc202a60-52/s540x810/354d3bb77529611af4765ca79df04217c0a45c21.png",
    sub_img: "https://66.media.tumblr.com/8045d42cc40bbb37b42081b152c0bb36/1368a1bdbc202a60-52/s540x810/354d3bb77529611af4765ca79df04217c0a45c21.png",
    description: "Tikar Mengkuang has two functions: To dry rice or as mats. It is usually woven from Pandan or Nipah leaves. Tikar Mengkuang that serves as mats in the kitchen are usually not dipped in colours. Only mats that are reserved for guests came in other colours. ",
    url: "Tikar-Mengkuang"
  },

  {
    name: "Congkak Board",
    img_src: "https://66.media.tumblr.com/9c2ce16999a002de117dbe603f98fe36/a8a7d8451aa9da6f-cd/s540x810/3c2c88800845f893310ce8382880f782f2fb0d3c.png",
    sub_img: "https://66.media.tumblr.com/9c2ce16999a002de117dbe603f98fe36/a8a7d8451aa9da6f-cd/s540x810/3c2c88800845f893310ce8382880f782f2fb0d3c.png",
    description: "Congkak is a traditional Malay board-like game. It is a game that requires two players to share the wooden board with one row of seven holes along each side, and one bigger hole at either end. The two rows of seven holes are designated as “houses” in the “village” (kampong) while the last two larger holes serve as “storehouses”, although there are variations.Seeds which were usually marbles or stones are placed in each hole, and then redistributed according to the rules of the game. The objective is to gain as many seeds in one’s storehouse as possible.",
    url: "Congkak"

  },

  {
    name:"Gasing",
    img_src:"https://66.media.tumblr.com/9d3d997bcbb40ecb884d56f0f9590c88/a8a7d8451aa9da6f-4b/s540x810/1f599f6f8ff9b5aec403f6169ca880bffb2874b3.png",
    sub_img:"https://66.media.tumblr.com/9d3d997bcbb40ecb884d56f0f9590c88/a8a7d8451aa9da6f-4b/s540x810/1f599f6f8ff9b5aec403f6169ca880bffb2874b3.png",
    description:"Gasing or spinning top was a popular game played in the villages among members of the Malay community. Competitive gasing is still played in Malaysia today. Usually constructed of wood and iron tip, string or rope coiled around the top which when pulled quickly caused the top to spin rapidly and balanced on its tip.",
    url:"Gasing"
  },


];